import './archive-featured-list.scss'

import { defineComponent, PropType } from 'vue';
import { pluck, tap } from 'rxjs/operators';

import { SearchParams, ArchiveResource, SearchResponse } from '@skinsoft/types';

import { NB_ARCHIVES_SEARCH_RESULT_CHANGED_TOPIC } from '@skinsoft/bus';
import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { TitleClickAction } from '../featured-card';
import { ArchiveFeaturedCard } from '@skinsoft/ui2'

export const ArchiveFeaturedList = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sArchiveFeaturedCard: ArchiveFeaturedCard,
    },
    props: {
        searchParams: { type: Object as PropType<SearchParams>, required: true },
        emptyMessage: String,
        titleClickAction: Object as PropType<TitleClickAction>,
        displayedButtons: {
            type: Array,
        },
    },
    template: require('./archive-featured-list.html'),
    data() {
        return {
            archiveFeatureds: [] as ArchiveResource[],
            totalResults: 0,
        }
    },
    methods: {
        subscribe() {
            const locale = this.getAppLocale()
            const sortObject =
                this.searchParams?.sortType?.length > 0
                    ? { entityFields: this.searchParams.sortType, sortAsc: this.searchParams.sortAsc }
                    : null

            this.subscribeTo(
                this.$archiveDataStore.searchAll(
                    {
                        queryText: this.searchParams.queryText,
                        sortObject: sortObject,
                        pageSize: this.searchParams.nbResults,
                        language: this.getAppLocale(),
                    },
                ).pipe(
                    tap((result: SearchResponse<ArchiveResource>) => {
                        this.totalResults = result.totalSize
                    }),
                    pluck<SearchResponse<ArchiveResource>, ArchiveResource[]>('allData')
                ),

                (archives: ArchiveResource[]) => {
                    this.archiveFeatureds = archives
                    this.emitOnBus(NB_ARCHIVES_SEARCH_RESULT_CHANGED_TOPIC, { nbResults: archives.length, totalResults: this.totalResults });
                },

                'archiveFeatureds',
            )
        },
        unsubscribe() {
            this.unsubscribeFrom('archiveFeatureds')
        },
    },
    watch: {
        searchParams: {
            handler() {
                // Testing all search params presence to avoid useless search query during params setting
                if (this.searchParams.nbResults && this.searchParams.sortType?.length) {
                    this.unsubscribe()
                    this.archiveFeatureds = []
                    this.$emit('totalCount', null)
                    this.subscribe()
                }
            },
            immediate: false,
            deep: true,
        },
    },
})
